<template> 
  <div class="insurance">
    <div class="banner">
      <img :src="$store.state.isMB?'static/mbimages/insurance/banner.jpg':'static/images/insurance/banner_insurance.jpg'" alt="">
      <div class="textNtitle">
        <div class="banner_title">构建理赔生态资源平台</div>
        <div class="banner_text">提供车险服务相关的产品，以助力企业打通理赔全流程可视链路，优化内部作业流转效率
            <br>辅助管控理赔风险与经营支出，完善客户理赔服务体系
        </div>
      </div>
    </div>
    <div class="specialist">
      <div>
        <div class="solution">
            <img src="static/images/insurance/icon1.png" alt="">
            <div class="title">定核损一体化解决方案</div>
            <ul>
            <li>• 定核报智能全流程系统</li>
            <li>• 移动查勘定损系统</li>
            <li>• 案件风险筛查管理</li>
            <li>• 理赔定价管理</li>
            <li>• 维修厂管理平台</li>
            <li>• 人伤管理平台</li>
            </ul>
        </div>
        <div class="solution">
            <img src="static/images/insurance/icon2.png" alt="">
            <div class="title">理赔多场景业务管理解决方案</div>
            <ul>
            <li>• 在线理赔处理平台</li>
            <li>• 智能调度管理系统</li>
            <li>• 理赔协作资源管理</li>
            <li>• 可视化数据分析</li>
            </ul>
        </div>
      </div>
      <div class="varietyList">
        <div class="variety" v-for="(item, index) in vList" :key="item.tip">
          <img :src="item.url" alt="">
          <div class="tip" :class="index==1?'sametype':''">{{item.tip}}</div>
        </div>
      </div>
    </div>
    <div style="background:#f5f5f5;">
      <div class="strengths">
        <div class="info_title">
          <span>创新理赔</span>
        </div>
      <span class="explain">东升在线理赔创新采用工作台集成模式，统一工作平台、统一用户接触、统一业务管理，将人机可视化多媒体交互与传统工单作业相结合，这是适应行业理赔发展的需求。通过多年来对理赔业务场景的丰富经验、充分发挥新的技术和用户多频媒介整合，实现新的在线理赔作业场景。可适应保险行业大中小企业多种需求。</span>
      <div class="mode">统一工作平台、统一用户接触、统一业务管理</div>
      <img class="bg1" :src="$store.state.isMB?'static/mbimages/insurance/bg1.png':'static/images/insurance/strengths.jpg'" alt="">
      <img class="bg2" src="static/mbimages/insurance/bg2.jpg" alt="">
      </div>
    </div>
    <div class="datatype">
      <div class="info_title">
        <span>数字理赔</span>
      </div>
      <img :src="$store.state.isMB?'static/mbimages/insurance/bg3.jpg':'static/images/insurance/datatype.jpg'" alt="">
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      vList: [
        { url: 'static/images/insurance/icon3.png', tip:'提高业务过程透明度' },
        { url: 'static/images/insurance/icon4.png', tip:'提高作业流程效率' },
        { url: 'static/images/insurance/icon5.png', tip:'降低理赔成本' },
        { url: 'static/images/insurance/icon6.png', tip:'降低企业运营成本' }
      ]
    }
  },
  mounted () {
    window.scroll(0,0)
  },
}
</script>
<style lang="scss">
.insurance{
  .banner{
    .textNtitle{
      @media screen and (max-width: 767px) {
        top: 24%;
      }
    }
    .banner_text{
      font-size: 18px;
      line-height: 30px;
      @media screen and (max-width: 767px) {
        font-size: 14px;
        line-height: 24px;
      }
    }
  }
  .specialist{
      padding: 86px 0;
      @media screen and (max-width: 767px) {
        padding: 50px 4% 10px;
      }
    & > div{
      width: 1200px;
      display: flex;
      justify-content: space-between;
      margin: auto;
      @media screen and (max-width: 767px) {
        width: 100%;
        flex-wrap: wrap;
      }
    }
    .varietyList{
      margin-top: 20px;
      @media screen and (max-width: 767px) {
        margin-top: 0;
      }
       .sametype{
          @media screen and (max-width: 767px) {
            margin-top: 0 !important;
          }
        }
    }
    img{
      display: block;
      margin: auto;
      @media screen and (max-width: 767px) {
        width: 55px;
      }
    }
    .solution{
      width: 590px;
      height: 350px;
      background: #f5f5f5;
      padding-top: 50px;
      @media screen and (max-width: 767px) {
        width: 100%;
        height: fit-content;
        padding: 5vw 0 3vw;
        margin-bottom: 30px;
      }
      .title{
        line-height: 59px;
        letter-spacing: 0px;
        color: #e72428;
        font-size: 18px;
        width: fit-content;
        margin: 0 auto 19px;
        @media screen and (max-width: 767px) {
          line-height: 15vw;
          margin-bottom: 0;
        }
      }
      ul{
        width: 373px;
        display: flex;
        flex-wrap: wrap;
        list-style: none;
        padding: 0;
        margin: auto;
        @media screen and (max-width: 767px) {
          width: 250px;
        }
        li{
          font-size: 14px;
          width: 160px;
          margin-bottom: 17px;
          @media screen and (max-width: 767px) {
            width: 140px;
            margin-right: 0;
            font-size: 12px;
          }
        }
        li:first-child,li:nth-child(3),li:nth-child(5){
          margin-right: 90px;
          @media screen and (max-width: 767px) {
            margin-right: 0;
          }
        }
        li:nth-child(2),li:nth-child(4),li:nth-child(6){
          width: 123px;
          @media screen and (max-width: 767px) {
            width: fit-content;
          }
        }
      }
    }
    .variety{
      width: 285px;
      height: 126px;
      background: #f5f5f5;
      padding-top: 25px;
      @media screen and (max-width: 767px) {
        width: 48%;
        margin-bottom: 20px;
      }
      img{
        @media screen and (max-width: 767px) {
          width: 34px;
        }
      }
      .tip{
        width: fit-content;
        margin: auto;
        line-height: 42px;
        font-size: 18px;
        @media screen and (max-width: 767px) {
          font-size: 14px;
          margin-top: 10px;
        }
      }
    }
  }
  .strengths{
    width: 1200px;
    margin: auto;
    padding: 75px 0 88px;
    @media screen and (max-width: 767px) {
      width: 100%;
      padding: 40px 4% 30px;
    }
    .info_title{
      margin: 0 0 40px;
      width: 162px;
      border-right: none;
      @media screen and (max-width: 767px) {
        width: 120px;
        margin-bottom: 20px;
      }
    }
    .explain{
      line-height: 32px;
      @media screen and (max-width: 767px) {
        line-height: 24px;
        font-size: 14px;
      }
    }
    .mode{
      width: fit-content;
      margin: 37px auto 66px;
      font-size: 30px;
      font-weight: bold;
      @media screen and (max-width: 767px) {
        font-size: 16px;
        margin: 40px auto;
      }
    }
    .bg1{
      display: block;
      margin: auto;
      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }
    .bg2{
      @media screen and (min-width: 768px) {
        display: none;
      }
      margin-top: 40px;
      width: 100%;
    }
  }
  .datatype{
    width: 1200px;
    margin: auto;
    padding: 94px 0 57px;
    @media screen and (max-width: 767px) {
      width: 100%;
      padding: 40px 4% 40px;
    }
    img{
      @media screen and (max-width: 767px) {
        width: 100%;
      }
    }
    .info_title{
      margin: 0 0 40px;
      width: 162px;
      border-right: none;
      @media screen and (max-width: 767px) {
        width: 120px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/comPages/insurance.vue